import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { library } from '@fortawesome/fontawesome-svg-core';
import _get from 'lodash/get';
import _keys from 'lodash/keys';
import _values from 'lodash/values';
import { iconLibraries, fontAwesomeIconMap } from './Icon.constants';
export function initializeFontAwesomeLibrary() {
  library.add.apply(library, _toConsumableArray(_values(fontAwesomeIconMap)));
}
export function getLibraryFromIconName() {
  var iconName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _keys(fontAwesomeIconMap).includes(iconName.toLowerCase()) ? iconLibraries.FontAwesome : iconLibraries.SemanticUI;
}
export function getFontAwesomeIcon() {
  var iconName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _get(fontAwesomeIconMap, iconName.toLowerCase());
}